<template lang="html">
  <v-combobox
    ref="input"
    v-model="internalValue"
    v-bind="$attrs"
    :label="internalLabel"
    :rules="internalRules"
    data-lpignore="true"
    autocomplete="off"
    v-on="$listeners"
  >
    <!-- <template v-slot:item="{ item, index, on }">
      <v-list-item :key="index" v-on="on" v-if="isObject(item)">
        <v-list-item-icon v-if="item.icon">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{item.text}}</v-list-item-title>
          <v-list-item-subtitle v-if="item.subtext">{{item.subtext}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :key="index" v-else v-on="on">
        <v-list-item-content>
          <v-list-item-title>{{item}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template> -->
    <slot />
  </v-combobox>
</template>

<script>
import element from '@/mixins/element'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers, element ],
  props: {
    value: [String, Array, Object]
  },
  data () {
    return {
      lazyValue: this.value,
      requiredRule: v => this.selectRequiredRule(v)
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
